import { getViewportInfo } from '../../../../../utils';
import {
  COLLAPSED_HEIGHT_CONFIG_KEY,
  DESKTOP,
  EXPANDED_HEIGHT_CONFIG_KEY,
  FULL_OPACITY,
  HEIGHT_AUTO,
  MOBILE,
  TABLET,
  UNSET,
} from './useAccordionTransition.constants';

/**
 * Get final height for expand/collapse animation
 *
 * @param {boolean} isExpanded
 * @param {object} transitionConfig
 * @returns {number} finalHeight
 */
export const getFinalHeightForTransition = (isExpanded, transitionConfig = {}) => {
  const expansionStatusKey = isExpanded ? EXPANDED_HEIGHT_CONFIG_KEY : COLLAPSED_HEIGHT_CONFIG_KEY;
  let viewportKey = MOBILE;
  const { isTablet, isDesktop } = getViewportInfo() || {};
  if (isTablet) {
    viewportKey = TABLET;
  }
  if (isDesktop) {
    viewportKey = DESKTOP;
  }
  return transitionConfig?.[expansionStatusKey]?.[viewportKey];
};

/**
 * Util to set styles for section collapse/expand animation
 *
 * @param {ref} containerRef
 * @param {object} styles
 */
/* eslint-disable no-param-reassign */
export const setStylesToRef = (
  containerRef,
  { display = '', overflowY = '', height = HEIGHT_AUTO, opacity = FULL_OPACITY, transition = UNSET }
) => {
  containerRef.current.style.display = display;
  containerRef.current.style.overflowY = overflowY;
  containerRef.current.style.height = height;
  containerRef.current.style.opacity = opacity;
  containerRef.current.style.transition = transition;
};

/**
 * Cleanup animation frames and timeout
 */
export const cleanupAnimation = (timeoutId, initialAnimationFrameId, finalAnimationFrameId) => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  if (initialAnimationFrameId) {
    cancelAnimationFrame(initialAnimationFrameId);
  }
  if (finalAnimationFrameId) {
    cancelAnimationFrame(finalAnimationFrameId);
  }
};

export default { getFinalHeightForTransition, setStylesToRef };
